module.exports = __webpack_public_path__ + "img/按摩足浴桶.0922fd84.png";